import { useHotels } from 'app/hooks/data/hotels/useHotel';

import { AssetDetailTitle } from './AssetDetailTitle';

type PackDetailTitleProps = {
  packageId?: number | null;
  hotelId?: number;
  aliasForHotel?: string;
};

export const PackDetailTitle = ({
  packageId,
  hotelId,
  aliasForHotel,
}: PackDetailTitleProps) => {
  const { data: hotels } = useHotels();
  const hotel = hotels?.find((h) => h.id === hotelId);
  const name = aliasForHotel?.trim();

  return (
    <AssetDetailTitle
      assetTitle={name && name.length ? name : `Package #${packageId}`}
      hotelId={hotel?.id}
      hotelName={hotel?.name}
      isNewDataModel={false}
    />
  );
};
